<template>
  <div class="container-fluid">
    <b-row style="margin-top: 50px;" v-show="!loading">

      <b-col sm="12" md="4" v-for="config in companyConfigs" :key="config.value">
        <router-link :to="{name: 'CompanyDashboard', params: {id: config.companyId}}">

          <b-card :style="{backgroundColor: config.backgroundColor}">

            <div class="text-right mb-4" style="width: 40%; margin: 0 auto;">
              <img :src="config.logo" class="img-fluid">
            </div>

            <p class="text-uppercase font-weight-bold text-center" :style="{color: config.secondaryColor}">
              {{config.companyId}}
            </p>
          </b-card>
        </router-link>
      </b-col>
    </b-row>


    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>

  </div>
</template>


<script>
  import Loading from 'vue-full-loading'
  import store from './store'

  // Mixins
  import SSR from './ssr';
  import PersonAuth from './PersonAuth'


  export default {
    name: "Home",
    mixins: [PersonAuth, SSR],
    components: {Loading},

    data() {
      return {
        store: store,
        state: store.state,
        loading: false,
        loadingLabel: "Loading Companies.."
      }
    },

    created() {
      this.getBaseUrls()

        .then(() => {

          if (this.companyConfigs.length <= 1) {
            this.store.clearCompanyConfigs();
            this.loading = true;


            this.getCompanyIds().then(res => {

              let companyIds = res.body.items;

              companyIds.forEach(companyId => {

                let accessToken = this.store.getCompanyAccessToken(companyId);

                if (!accessToken) {


                  this.getCompanyIdAccessToken(companyId).then(res => {


                    this.store.setCompanyIdAccessToken(companyId, res.body);

                    this.getCompanyUIConfig(companyId, res.body).then(res => {

                      let config = {
                        companyId: companyId,
                        logo: res.body.logo,
                        headerImg: res.body.header_img,
                        clickIcon: res.body.click_icon,
                        primaryColor: res.body.primary_color,
                        secondaryColor: res.body.secondary_color,
                        backgroundColor: res.body.background_color
                      };

                      this.store.setCompanyConfig(companyId, config)

                    }, err => {
                      console.log(err);
                    }).then(() => {
                      this.loading = false;
                    })

                  }, err => {
                    console.log(err);
                  });

                } else {

                  this.getCompanyUIConfig(companyId, accessToken).then(res => {

                    let config = {
                      companyId: companyId,
                      logo: res.body.logo,
                      headerImg: res.body.header_img,
                      clickIcon: res.body.click_icon,
                      primaryColor: res.body.primary_color,
                      secondaryColor: res.body.secondary_color,
                      backgroundColor: res.body.background_color
                    };

                    this.store.setCompanyConfig(companyId, config);
                  }, err => {
                    console.log(err);
                  }).then(() => {
                    this.loading = false;
                  })
                }
              }, err => {
                console.log(err)
              });

            }, err => {
              console.log(err)
            });
          }
        })
    },

    methods: {
      getCompanyIds() {
        return this.$http.get(`${this.olBaseURL}/companies`, {
          headers: {
            Authorization: `Bearer ${this.personToken}`,
          }
        })
      },

      getCompanyUIConfig(companyId, accessToken) {
        return this.$http.get(`${this.olBaseURL}/companies/${companyId}/ui-config`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          }
        })
      },

      getCompanyIdAccessToken(companyId) {
        return this.$http.post(`${this.portalBaseURL}/me/access-token`, {company_id: companyId}, {
          headers: {
            Authorization: `Bearer ${this.personToken}`
          }
        })
      }
    },

    computed: {
      companyConfigs() {
        return this.state.companyConfigs;
      },

      personToken() {
        return this.state.personToken
      },
    }
  }
</script>

<style scoped>

</style>
